import script from "./DreamMeetEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./DreamMeetEntry.vue?vue&type=script&setup=true&lang=js"

import "./DreamMeetEntry.vue?vue&type=style&index=0&id=4a54c048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a54c048"]])

export default __exports__